import React from "react";
import { getPaginationInterval } from "@lib/helpers";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

// bricostore-only pagination overrides (circular/pill shape + red active border); altex/MG untouched
// replace (not append) the radius so there's a single rounded-* class → no cascade conflict
const pageRadius = isBricoStore ? "rounded-full" : "rounded-md";
const activePageClass = isBricoStore
  ? "bg-red-brand text-white border-red-brand"
  : "bg-alertRed text-white";

const Pagination = ({
  pages,
  goTo,
  activePage,
  meta = {},
  showMeta = false,
  alignment = "justify-end",
}) => {
  if (!pages || !goTo || !activePage || pages < 2) {
    return null;
  }

  const pagesArr = [];
  for (let index = 1; index <= pages; index++) {
    pagesArr.push(index);
  }

  return (
    <div className="Toolbar flow-root">
      <div
        className={`flex flex-wrap items-center py-3 lg:pb-15px ${alignment}`}
      >
        {showMeta && (
          <div className="text-sm w-full text-center mb-20px sm:mb-0 sm:text-left sm:w-auto sm:block md:pr-2">
            {meta.limit * meta.page + 1} -
            {(meta.page + 1) * meta.limit < meta.size
              ? meta.limit * (meta.page + 1)
              : meta.size}{" "}
            din {meta.size} de recenzii
          </div>
        )}

        <button
          type="button"
          className={`${
            activePage == 1
              ? "text-gray cursor-not-allowed pointer-events-none"
              : ""
          } inline-block py-1 px-2 mx-1 text-sm border border-gray-1100 ${pageRadius} items-center text-center bg-white`}
          title={`Inapoi`}
          onClick={(e) => {
            activePage > 1 ? goTo(activePage - 1) : e.preventDefault();
          }}
        >
          <div className="hidden md:inline-block">Pagina anterioara</div>
          <div className="Toolbar-previous md:hidden"></div>
        </button>

        <nav className="flex justify-center">
          <ul className="flex list-none m-0 p-0">
            {getPaginationInterval(pagesArr, activePage - 1).map((page, i) => (
              <React.Fragment key={`fragment-${page}-${i}`}>
                {(page <= 20 || page === "...") && (
                  <li defaultValue={activePage} key={`${page}-${i}`}>
                    <button
                      type="button"
                      className={`
                    mx-1 text-sm flex w-8 h-8 items-center justify-center border border-gray-1100 ${pageRadius}
                    ${page == activePage ? activePageClass : "bg-white"}
                    ${
                      page == activePage || page == "..."
                        ? "cursor-not-allowed pointer-events-none"
                        : ""
                    }
                  `}
                      onClick={() => {
                        goTo(page);
                      }}
                    >
                      {page}
                    </button>
                  </li>
                )}
              </React.Fragment>
            ))}
          </ul>
        </nav>

        <button
          type="button"
          className={`${
            activePage == pages
              ? "text-gray cursor-not-allowed pointer-events-none"
              : ""
          } inline-block py-1 px-2 mx-1 text-sm border border-gray-1100 ${pageRadius} items-center text-center bg-white`}
          title={`Inainte`}
          onClick={(e) => {
            activePage != pages ? goTo(activePage + 1) : e.preventDefault();
          }}
        >
          <div className="hidden md:inline-block">Pagina urmatoare</div>
          <div className="Toolbar-next md:hidden"></div>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
